import React, { useEffect, useState } from "react";
import {
  FolderOpenOutlined,
  EditOutlined,
  CloseOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import AddSection from "../addSection/AddSection";
import AddQuizQuestion from "../quizQuestion/AddQuizQuestion";
// import SortSection from "./CurriculumTab/SortSection";

import UpdateLesson from "../updateLesson/UpdateLesson";
import useGetApi from "../../services/useGetApi";
import useDelete from "../../services/useDelete"
import { useParams } from "react-router-dom";
import usePost from "../../services/usePost";
import AddLesson from "../addLesson/AddLesson";
import AddQuiz from "../addQuiz/AddQuiz";
import ConfirmationPopup from "../confirmationPopup/ConfirmationPopup";
// import AddQuizQuestion from '../'
// // import AddQuizQuestion from "./CurriculumTab/AddQuizQuestion";

const CurriculumCard = () => {
  const [editSectionBtn, setEditSectionBtn] = useState(false);
  // const []
  const [sourceFile, setSourceFile] = useState(false);
  const [updateLessonBtn, setUpdateLessonBtn] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const {id} = useParams()
  const [lesson,setLesson] = useState()
  const [addSectionBtn,setAddSectionBtn] = useState(false)
  const [addLessonBtn,setAddLessonBtn] = useState(false)
  const [addquizbtn,setAddQuizBtn] = useState(false)
  const [sortSectionBtn,setSortSectionBtn] = useState(false)
  const [sectionEditId,setSectionEditId] = useState()
  const [section,setSection] = useState()
  const [lessonEditId,setLessonEditId] = useState()
  const [addQuizQuestion,setAddQuizQuestion] = useState()
  const [quizSectionId,setQuizsectionId] = useState()
  const [quizId,setquizId] = useState()
  const [editQuizBtn,setEditQuizBtn] = useState(false)
  const [mode,setMode] = useState('')


   const [
      sectionsIsLoading,
      sectionsError,
      sections,
      getSections,
    ] = useGetApi(`course/details/${id}`, [], true);

    const [
      quizIsLoading,
      quizError,
      quiz,
      getQuiz,
    ] = useGetApi(`course/details/${id}`, [], true);

  const [isDeleteLoading, deleteError, deleteData] = useDelete();
    // useEffect(() => {
    //   console.log(quizSectionId,'/.........');
      
    // },[quizSectionId])
    
    useEffect(() => {
      getSections(`course/details/${id}`)
    },[id])

    const handleDelete = async () => {
      
      if (lesson?.id ) {
        // console.log('delete lesson.........................')
        try {
          const response = await deleteData(`lessons/${lesson.id}`, {}, true);
          if (response) {
            setConfirmation(false)
            getSections(`course/details/${id}`)
          } 
        } catch (error) {
          console.error('Error deleting lesson:', error);
        }
      } 

      else if(section?.id){
        
        // console.log('delete section........................')
        // console.log('dek')
        try {
          const response = await deleteData(`sections/${section?.id}`, {}, true);
          if (response) {
            setConfirmation(false)
            getSections(`course/details/${id}`)
          } 
        } catch (error) {
          console.error('Error deleting lesson:', error);
        }
      }

      else if (quizId) {
        // // Deleting quiz
        // console.log('delete quiz.........................')
        try {
          const response = await deleteData(
            `sections/course/${id}/section/${quizSectionId}/quiz/${quizId}`
            , {}, true
          );
          if (response) {
            setConfirmation(false);
            getSections(`course/details/${id}`);
          }
        } catch (error) {
          console.error('Error deleting quiz:', error);
        }
      }
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    
    // useEffect(() => {
    //   console.log(quizId,'................')
    // },[quizId])
  

  return (
    <div>
                             <div>
                                <button
                                  type="button"
                                  className="curriculum_top_btn"
                                  onClick={() => setAddSectionBtn(true)}
                                >
                                  <PlusOutlined /> Add section
                                </button>
                                 <AddSection addSectionBtn={addSectionBtn} 
                                     setAddSectionBtn={setAddSectionBtn} 
                                     title={'Add new section'}
                                     getSections={getSections}
                                  />

                                <button 
                                   type="button"
                                   className='curriculum_top_btn' 
                                   onClick={() => setAddLessonBtn(true)}><PlusOutlined/>
                                   Add lesson
                                </button>
                                {addLessonBtn && 
                                  <AddLesson 
                                  addLessonBtn={addLessonBtn} 
                                  setAddLessonBtn={setAddLessonBtn}
                                  loadSections={getSections}
                                  />
                                  
                                }
                                  
                                <button 
                                  className='curriculum_top_btn'
                                  type="button" 
                                  onClick={() => {
                                    setMode('add')
                                    setAddQuizBtn(true)
                                  }}>
                                  <PlusOutlined />Add quiz
                                </button>
                                  {addquizbtn && 
                                     <AddQuiz 
                                       addQuizBtn={addquizbtn}
                                       setAddQuizBtn={setAddQuizBtn}
                                       mode={mode}
                                       loadSections={getSections}
                                       quizId={quizId}
                                       quizSectionId={quizSectionId}
                                      />
                                  }

                                {/* <button 
                                 className='curriculum_top_btn'
                                 type="button"
                                 onClick={() => setSortSectionBtn(true)}>
                                 Sort sections
                                </button>
                                  {sortSectionBtn && <SortSection sortSectionBtn={sortSectionBtn} setSortSectionBtn={setSortSectionBtn} title={'Sort sections'}/>} */}
                             </div>
      <div style={{marginTop:'30px'}}>
        {sections?.sections?.map((section, sectionIndex) => (
          <div className="curriculum_card">
            <div key={section.id} className="section_card">
              <div className="curriculum_top_div">
                <p>
                  Section {sectionIndex}: <strong>{section.title}</strong>
                </p>
                <div className="edits_div">
                  {/* <button
                    className="editor_btns"
                    onClick={() => setSortSectionBtn(true)}
                  >
                    Sort lessons
                  </button> */}
                  <button
                    className="editor_btns"
                    type="button"
                    onClick={() => {
                      setSectionEditId(section.id)
                      setEditSectionBtn(true)
                      scrollToTop()
                    }}
                  >
                    Edit section
                  </button>
                  <button
                    className="editor_btns"
                    type="button"
                    onClick={() =>{
                      setConfirmation(true)
                      setSection(section)
                      scrollToTop()
                    }}                  
                  >
                    Delete section
                  </button>
                  <AddSection
                    addSectionBtn={editSectionBtn}
                    setAddSectionBtn={setEditSectionBtn}
                    title={"Update section"}
                    sectionEditId={sectionEditId}
                    getSections={getSections}
                  />
                  {/* <SortSection
                    sortSectionBtn={sortSectionBtn}
                    setSortSectionBtn={setSortSectionBtn}
                    title={"Sort lessons"}
                  /> */}
                  <ConfirmationPopup
                    confirmation={confirmation}
                    setConfirmation={setConfirmation}
                    handleDelete={handleDelete}
                  />
                </div>
              </div>

             {/* Map through lessons in each section */}
            <div className="lesson_div">
              {section.lessons?.map((lesson,index) => (
                <div key={lesson.id} className="lesson_card">
                  <p>
                    Lesson {index}: {lesson.title}
                  </p>
                  <div style={{display:'flex', gap:'10px'}}>
                    <FolderOpenOutlined onClick={() => setSourceFile(true)} />
                    <EditOutlined onClick={() => {
                      setUpdateLessonBtn(true)
                      setLessonEditId(lesson?.id)
                      scrollToTop()
                    }} />
                    <CloseOutlined
                      onClick={() => {
                        setConfirmation(true);
                        setLesson(lesson);
                        scrollToTop()
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
            {/* <AddSourceFile sourceFile={sourceFile} setSourceFile={setSourceFile} /> */}
            <UpdateLesson
              updateLessonBtn={updateLessonBtn}
              setUpdateLessonBtn={setUpdateLessonBtn}
              lessonEditId={lessonEditId}
              loadSections={getSections}

            />

            <div className="lesson_div">
              {section.quizzes?.map((quiz,index) => (
                <div key={quiz.id} className="lesson_card">
                  <p>
                    Quiz {index}: {quiz.title}
                  </p>
                  <div style={{display:'flex', gap:'10px'}}>
                    <QuestionCircleOutlined 
                      onClick={() => {
                        setAddQuizQuestion(true)
                        // console.log(quiz?.id,'........')
                        setQuizsectionId(section?.id)
                        setquizId(quiz?.id)
                        scrollToTop()
                      }}
                    />
                    <EditOutlined onClick={() => {
                     {
                    //  console.log(quiz.id,section?.id,quiz?.title,section?.title,'.,.,.,.,..,.,.')
                      setMode('edit')
                      setquizId(quiz?.id)
                      setQuizsectionId(section?.id);
                      setAddQuizBtn(true)
                      scrollToTop()
                     }
                    }} />
                    <CloseOutlined    
                      onClick={() => {
                        setConfirmation(true);
                        // setLesson(lesson);
                        setQuizsectionId(section?.id); 
                        setquizId(quiz?.id); 
                        scrollToTop()
                      }}
                    />
                    <AddQuizQuestion 
                      addQuizQuestion={addQuizQuestion}
                      setAddQuizQuestion={setAddQuizQuestion}
                      quizSectionId={quizSectionId}
                      quizId={quizId}
                      loadSections={getSections}

                    />
                   
                  </div>
                </div>
              ))}
            </div>
          </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CurriculumCard;
